module.exports = __webpack_public_path__ + "media/icons/arrow-right-square@3x-6a4a420f.svg";